module.exports = __webpack_public_path__ + "img/black.47490d15.svg";